import { Component, Inject, OnInit } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { InputModalModel } from '@shared/models'
import { FormHelperService } from '@widgets/form/services/form-helper.service'

@Component({
  templateUrl: './text-area.component.html',
})
export class TextAreaComponent implements OnInit {
  title: string
  message: string
  primaryOption: string
  secondaryOption: string
  label: string
  form: FormGroup
  validator: any
  primaryOptionColor: string = 'primary'
  maxLength: number = 600
  placeholder: string
  constructor(@Inject(MAT_DIALOG_DATA) data, private formHelper: FormHelperService) {
    this.title = data.title
    this.message = data.message
    this.primaryOption = data.primaryOption
    this.secondaryOption = data.secondaryOption
    this.label = data.label
    this.validator = data.validator
    this.placeholder = data.placeholder
    this.primaryOptionColor = data.primaryOptionColor != undefined ? data.primaryOptionColor : this.primaryOptionColor
    this.maxLength = data.maxLength != undefined ? data.maxLength : this.maxLength
  }
  ngOnInit(): void {
    this.form = this.formHelper.createForm<InputModalModel>(
      {
        input: '',
      },
      {
        input: null,
      }
    )
  }
  get control() {
    return this.form.controls.input as FormControl
  }
}
